import { FC } from 'react';
import RefinementSalesOffersList from '../RefinementList/RefinementSalesOffersList';
import styles from '../FilterDrawer.module.scss';

type SalesOffersFilterAttributePanelProps = {
    isActive: boolean;
};

// Own panel component so RefinementSalesOffersList's useSalesOfferGroups mounts once, not once per facet panel.
export const SalesOffersFilterAttributePanel: FC<SalesOffersFilterAttributePanelProps> = ({
    isActive,
}) => (
    <div hidden={!isActive} className={styles.enterForward}>
        <RefinementSalesOffersList />
    </div>
);
